<template>
  <div id="toast-container"></div>
  <n-message-provider>
    <router-view />
  </n-message-provider>
</template>

<style>
#app {
  padding: 0 !important;
  display: block;
  width: 100%;
  margin: 0;
}
</style>